module.exports = __webpack_public_path__ + "static/media/Prof.-Dr.-M.-A-Khan.a22ec3ee.png";